import "../dictionary";
import { writable } from 'svelte/store';
import "../data/charmapping";
import { groups, professions } from "../data/data";
import { initGroups } from "../groups/group";
import { initFighting } from "./fighsystem";
import { initWeapons } from "../weapons/weapon";
export function initCharacter() {
    const progressions = {
        magicList: [0, 3, 2, 1, 0.5],
        bodyList: [0, 3, 2, 1, 0.5],
        magicJson: "[0,3,2,1,0.5]",
        bodyJson: "[0,3,2,1,0.5]"
    };
    const characterAttributes = {
        ge: 0,
        ko: 0,
        gd: 0,
        lo: 0,
        sd: 0,
        em: 0,
        in: 0,
        ch: 0,
        re: 0,
        st: 0
    };
    const commonAttributes = {
        name: "",
        race: "",
        raceProgression: "",
        class: "",
        player: ""
    };
    const resistance = {
        essence: 0,
        lead: 0,
        mental: 0,
        poison: 0,
        sicknes: 0,
        fear: 0,
        heath: 0,
        cold: 0,
        soulforce: 0,
        healingMultiplicator: 0,
    };
    const appearance = {
        sex: "",
        age: 0,
        height: 0,
        weight: 0,
        appearance: "",
        stature: "",
        haircolor: "",
        throwing: "",
        special: "",
    };
    const defense = {
        basic: characterAttributes.re * 3,
        total: 0,
        initiative: 0,
        armorClass: 0
    };
    const character = {
        id: crypto.randomUUID(),
        level: {
            level: 0,
            experience: 0,
            inspirationPoints: 0
        },
        characterAttributes,
        profession: professions[0],
        fightAttributes: initFighting(),
        groups: initGroups(groups, characterAttributes, professions[0]),
        spellLists: [],
        commonAttributes,
        resistance,
        appearance,
        progressions,
        weapons: initWeapons(professions[0].ff),
        defense
    };
    return character;
}
export const characterStore = writable();
